<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >

 <v-spacer></v-spacer>
        <material-card
            :color="app.color"            
          >
          <v-layout wrap slot="header">
            <v-flex sm6 xs12>

              <span v-if="object !== undefined" class="title "> {{object.category.description}}</span><br>
              <span v-if="object !== undefined" class="subheading-1 "> {{object.details.name}}</span>
            </v-flex>
          </v-layout>


          <v-container fluid class="pa-3">
            <v-layout row>
              <v-spacer></v-spacer>

              <v-flex class="text-sm-right">

                <v-tooltip bottom dark>
                    <template #activator='data'>
                      <v-btn medium text="" icon="" color="transparent">
                        <v-icon  medium @click="app.details.show = true"  :color="app.color" v-on="data.on">mdi-clipboard-text-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Details aanpassen</span>
                </v-tooltip>     
                <v-tooltip bottom dark v-if="showTemplates == false">
                    <template #activator='data'>
                      <v-btn large text="" icon="" color="transparent">
                        <v-icon medium @click="showTemplates = true"  color="success" v-on="data.on">mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Nieuwe overeenkomst</span>
                </v-tooltip>     
                
                <v-tooltip bottom dark v-if="showTemplates == true">
                    <template #activator='data'>
                      <v-btn large text="" icon="" color="transparent">
                        <v-icon medium @click="showTemplates = false"  color="error" v-on="data.on">mdi-minus</v-icon>
                      </v-btn>
                    </template>
                    <span>Sluiten</span>
                </v-tooltip>     
              </v-flex>

            </v-layout>
          </v-container>

          <forms-render-details></forms-render-details>

          <v-expand-transition>
            <v-container fluid v-if="showTemplates == true" class="pa-5">
              <v-layout wrap justify-center="">
                <v-flex
                  v-for="(item, i) in templates"
                  :key="i"
                  class="expansion">
                    <v-card hover class="template-card flip-container" ontouchstart="this.classList.toggle('hover');" >
                    <div class="flipper">
                      <div style="width:100%;" class="front" >
                        <p style="min-height:82px; padding-top:50px;" class="headline text-center">{{item.owner}}</p>
                        <p style="min-height:25px;" class="subheading text-center">{{item.name}}</p> 
                        <p style="min-height:20px;" class="font-weight-bold body-1 text-center" >{{item.subtitle}}</p>              
                                                
                        <p style="padding:0px; margin:0px;" class="text-center caption">Versie: {{item.version}}</p>                                   
                        <p style="padding-bottom:25px;" class="text-center caption">Redactie : {{item.editor}}</p>
                                              
                      </div>
                      <div style="width:100%;" class="back">
                        <p style="min-height:82px; padding-top:50px;" class="headline text-center">{{item.owner}}</p>
                        <p style="min-height:25px;" class="subheading text-center">{{item.name}}</p> 
                        <p style="min-height:20px;" class="font-weight-bold body-1 text-center" >{{item.subtitle}}</p>              

                        <v-container justify-center="">
                          <v-layout class="pa-2">
                            <v-btn block :color="app.color" @click="createContract(item.reference)" rounded>aanmaken</v-btn>
                          </v-layout>
                        </v-container>

                      </div>
                    </div>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-expand-transition>

          <v-data-table
              v-if="contracts !== []"
              :sort-by="['created_date']"
              :sort-desc="[true]"              
              :headers="headers"
              :items="contracts"
              :search="search"
              :loading="app.contracts.loading"
              :footer-props="{
                itemsPerPageText: ''
              }">
            >
              <template v-slot:no-data>
                <v-layout v-if="app.contracts.loading" row justify-center="" class="pa-4">
                  Contracten ophalen
                </v-layout>

                <v-layout v-if="!app.contracts.loading" row justify-center="" class="pa-4">
                  Geen contracten gevonden
                </v-layout>
              </template>

              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-success text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template
                v-slot:item="props"
              >
              <v-slide-x-transition>
                <tr class="selectorRow">
          
                  <td>
                    <v-tooltip right="" dark>
                      <template #activator='data'>
                        <v-avatar v-on="data.on" size="32" :color="props.item.status.color" small>
                          <span class="white--text">{{props.item.created_by.initials}}</span>
                        </v-avatar>
                      </template>
                      <span class="caption">{{props.item.created_date | created}}</span><br>
                      <span class="caption">{{props.item.created_by.full_name}}</span><br>
                      <span class="caption">{{props.item.status.title}}</span>
                      

                    </v-tooltip>
                  </td>

                  <td @click="toContract(props.item.reference)">
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.parent.reference != null">{{props.item.parent.descriptor}} : {{props.item.parent.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_1 !== null">{{props.item.party_1.descriptor}} : {{props.item.party_1.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_2 !== null">{{props.item.party_2.descriptor}} : {{props.item.party_2.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_3 !== null">{{props.item.party_3.descriptor}} : {{props.item.party_3.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_4 !== null">{{props.item.party_4.descriptor}} : {{props.item.party_4.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_5 !== null">{{props.item.party_5.descriptor}} : {{props.item.party_5.title}}</p>
                      <p style="margin:4px;" class="party pa-0"  v-if="props.item.party_6 !== null">{{props.item.party_6.descriptor}} : {{props.item.party_6.title}}</p>
                  </td>
                  <td @click="toContract(props.item.reference)">
                    <span>{{props.item.template.name}}</span><br>
                    <span class="caption">{{props.item.template.subtitle}}</span>
                  </td>

                  <td @click="toContract(props.item.reference)" >
                    <v-chip small outlined :color="props.item.expiration_status">{{props.item.time_to_expire}}</v-chip>
                  </td>

                  <td>
                      <v-layout>
                        <v-icon v-if="object !== undefined" @click="showArchiveDialog({type:'contract',description:props.item.template.name, reference:props.item.reference})" size="22" id="delete">mdi-delete</v-icon>
                      </v-layout>
                    </td>
                </tr>
              </v-slide-x-transition>

              <dialog-delete></dialog-delete>
              
              </template>
  
            </v-data-table>

        </material-card>
      </v-flex>

    </v-layout>


  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment, { months } from "moment";

export default {
  filters: {
    moment(date) {
      moment.locale("nl");
      if (date != null) {
        return moment(date).format("LL");
      } else {
        return "N/A";
      }
    },
    created(date) {
      moment.locale("nl");
      return moment(date).format("LLL");
    },
    expiration_date(exp_date) {
      moment.locale("nl");

      var now = moment(now);
      var expiration = moment(exp_date);
      var delta = moment.duration(expiration.diff(now)).humanize(true);

      return delta;
    }
  },
  data: () => ({
    search: "",
    showDetails: false,
    showTemplates: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10 // -1 for All
    },
    headers: [
      {
        sortable: false,
        text: "",
        value: "created_by.full_name"
      },
      // {
      //   sortable: true,
      //   // text: "Object",
      //   value: "title"
      // },
      {
        sortable: true,
        text: "Partijen",
        value: "title"
      },
      {
        sortable: true,
        text: "Model",
        value: "title"
      },
      // {
      //   sortable: false,
      //   text: "Contract type",
      //   value: "duration"
      // },

      {
        sortable: false,
        text: "Resterende looptijd",
        value: "time_to_expire"
      }

      // {
      //   sortable: true,
      //   text: "Periode tot verlenging",
      //   value: "extention_date"
      // },
      // {
      //   sortable: true,
      //   text: "Periode tot indexering",
      //   value: "expiration_date"
      // }
    ]
  }),
  computed: {
    ...mapState(["object", "app", "contracts", "templates"]),
    ...mapState("app", ["form", "dossier"])
  },
  methods: {
    ...mapActions(["updateObject", "resetObject", "toObjects"]),
    ...mapMutations(["showArchiveDialog"]),
    toContract(reference) {
      this.$store.dispatch("toContract", {
        reference: reference
      });
    },
    createContract(template) {
      this.$store.dispatch("createContract", {
        parent: this.object.reference,
        template: template
      });
    }
  },
  created() {
    this.$store.dispatch("checkAuth");
  },
  beforeDestroy() {
    this.$store.state.app.dossier.show = false;
  }
};
</script>

<style scoped>
.party {
  /* font-style: bold; */
  text-overflow: ellipsis;
  font-size: 12.5px !important;
}
/* :after {
  content: "\A";
  white-space: pre;
} */

#panel {
  padding: 40px 20px 20px 20px;
}

.template-card {
  height: 100%;
  /* border-style: solid;
  border-width: 0.5px;
  border-color: grey; */
  border-radius: 20px;
}

.expansion {
  margin: 20px;
  max-width: 260px;
  min-width: 260px;
  height: 260px;
  min-height: 100%;
}

/* entire container, keeps perspective */
.flip-container {
  perspective: 1000px;
}
/* flip the pane when hovered */
.flip-container:hover .flipper,
.flip-container.hover .flipper {
  transform: rotateY(180deg);
}

/* flip speed goes here */
.flipper {
  transition: 0.4s;
  transform-style: preserve-3d;

  position: relative;
}

/* hide back of pane during swap */
.front,
.back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

/* front pane, placed above back */
.front {
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}

/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);
}

#delete {
  color: grey;
}
#delete:hover {
  color: #d3223c;
}
</style>
